module.exports = __webpack_public_path__ + "static/img/mb_bg.0cc7511.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mb_bg.png
// module id = 383t
// module chunks = 1